var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ViewSonicViewBoard {
    constructor(socket, log) {
        this.socket = socket;
        this.power = false;
        this.videoSelection = '000';
        this.volume = '050';
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'powerGet',
                regExp: /8(\d{2})gl000/i,
                callback: (match) => {
                    this.socket.send(`8${match[1]}rl00${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /8(\d{2})s!00(\d)/i,
                callback: (match) => {
                    this.power = match[2] === '1';
                    this.socket.send(`4${match[1]}+`);
                },
            },
            {
                name: 'videoInputGet',
                regExp: /8(\d{2})gj000/i,
                callback: (match) => {
                    this.socket.send(`8${match[1]}rj${this.videoSelection.padStart(3, '0')}`);
                },
            },
            {
                name: 'videoInputSet',
                regExp: /8(\d{2})s\x22([0-9a-f]{3})/i,
                callback: (match) => {
                    this.videoSelection = match[2];
                    this.socket.send(`4${match[1]}+`);
                },
            },
            {
                name: 'volumeGet',
                regExp: /8(\d{2})gf000/i,
                callback: (match) => {
                    this.socket.send(`8${match[1]}rf${this.volume}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /8(\d{2})s5([0-9a-f]{3})/i,
                callback: (match) => {
                    this.volume = match[2];
                    this.socket.send(`4${match[1]}+`);
                },
            },
            {
                name: 'volumeMuteGet',
                regExp: /8(\d{2})gg000/i,
                callback: (match) => {
                    this.socket.send(`8${match[1]}rg00${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /8(\d{2})s600(\d)/i,
                callback: (match) => {
                    this.volumeMute = match[2] === '1';
                    this.socket.send(`4${match[1]}+`);
                },
            },
        ];
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    wakeOnLan() {
        this.power = true;
        const port = this.socket.getPort();
        this.socket.setCanConnect(!(port === 4660 || port === 5000) || this.power);
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(!(port === 4660 || port === 5000) || this.power);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '000';
    }
}
ViewSonicViewBoard.emulatorType = 'socketEmulator';
ViewSonicViewBoard.key = '-LvpZqFPdm8NxNkwSCF4';
